if (!window.Shopify || !window.Shopify.designMode) {
  class TextMarqueeWall extends HTMLElement {
    connectedCallback() {
      this.initMarquee();
    }

    initMarquee() {
      const container = this.querySelector('.tmw-container');
      const ul = container.querySelector('.marquee-content');
      const ulWidth = ul.scrollWidth;
      const viewportWidth = window.innerWidth;
      const numClones = Math.ceil(viewportWidth / ulWidth) + 1;

      for (let i = 0; i < numClones; i++) {
        const clone = ul.cloneNode(true);
        container.appendChild(clone);
      }

      let start = 0;
      const speed = 0.9;

      function animate() {
        start -= speed;
        container.querySelectorAll('.marquee-content').forEach(content => {
          content.style.transform = `translateX(${start}px)`;
        });

        if (Math.abs(start) >= ulWidth) {
          start = 0;
        }

        requestAnimationFrame(animate);
      }

      animate();
    }
  }

  customElements.define('text-marquee-wall', TextMarqueeWall);
}